import React, { useState } from 'react';
import Modal from './Modal';
import {projectsData} from './projectsData';

const ProjectCard = () => {
    const [openModal, setOpenModal] = useState(false);
    const [id, setId] = useState(null);
    
    const handleModal = (id) => {
        setOpenModal(true);
        setId(id);
    }

    return (
        <div className='grid grid-cols-1  md:grid-cols-2 xl:grid-cols-3 gap-4 p-2 md:p-0 '>
            {projectsData.map(({_id, projectName, img})=>
                <div key={_id}>
                    <div className='group relative overflow-hidden cursor-pointer'>
                        <img src={img} alt="" className='w-full object-contain' />  
                        <div
                            className="absolute top-0 left-0 w-full h-0 flex flex-col justify-center items-center bg-indigo-700 dark:bg-slate-500 opacity-0 group-hover:h-full group-hover:opacity-[90%] duration-500">
                            <h1 className="text-2xl text-white">{projectName}</h1>
                            <span onClick={() => handleModal(_id)} className="mt-5 px-8 py-3 text-white rounded-full bg-amber-500 dark:bg-slate-700 hover:bg-amber-600 dark:hover:bg-slate-900 duration-300">See Details</span>
                        </div>
                    </div>
                </div>
            )}
            {openModal && <Modal setOpenModal={setOpenModal} id={id}/>}
        </div>
    );
};

export default ProjectCard;